import {
    AlertIcon,
    UndoIcon,
    LockIcon
} from "@primer/octicons-react";
import { Box, Checkbox, FormControl, Radio, TextInput } from "@primer/react";
import moment from "moment";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { crmSurveyFormApi } from "../../api/crmSurveyFormApi";
import { crmSurveyFormQuestionApi } from "../../api/crmSurveyFormQuestionApi";
import { crmSurveyResponseApi } from "../../api/crmSurveyResponseApi";
import { ICrmTicketVm } from "../../api/crmTicketApi";
import { apiGuestClient } from "../../api/apiGuestClient";
import { IDmChienDich } from "../../models/response/crm-survey/IDmChienDich";
import { dm_coso } from "../../models/response/category/dm_coso";
import CrmSurveyComboBox from "../../components/crm-survey";
import CrmSurveyComboBoxStatic from "../../components/crm-survey/CrmSurveyComboBoxStatic";
import ComboboxCoSo from "../../components/combobox-coso/ComboboxCoSo";
import TextTranslated from "../../components/text";
import Button from "../../components/ui/button";
import Text from "../../components/ui/text";
import { useCommonContext } from "../../contexts/common";
import { useCommonSelectedHook } from "../../hooks/useCommonSelectedHook";
import { eSurveyFormQuestionTypeId } from "../../models/eSurveyFormQuestionTypeId";
import { eSurveyQuestionTypeId } from "../../models/eSurveyQuestionTypeId";
import { ICrmSurveyAnswer } from "../../models/response/crm-survey/ICrmSurveyAnswer";
import { ICrmSurveyFormQuestionDataSource } from "../../models/response/crm-survey/ICrmSurveyFormQuestionDataSource";
import { ICrmSurveyFormActiveVm } from "../../models/response/crm-survey/ICrmSurveyFormVm";
import { ICrmSurveyResponse, ICrmSurveyResponseVm } from "../../models/response/crm-survey/ICrmSurveyResponse";
import SurveyFormBlock from "./SurveyFormBlock";

interface ICrmSurveyFormGoLivePageProps {
    isAttendance: boolean;
    dm_chiendich_id: number;
    crm_survey_form_id: number;
    uuid?: string | null;
}

const SurveyFormGoLivePage = (props: ICrmSurveyFormGoLivePageProps) => {
    const [isSaving, setIsSaving] = useState(false);

    const { register, handleSubmit, trigger, formState: { errors } } = useForm();
    const { nam_hoc, dm_coso_id } = useCommonSelectedHook();
    const temp = {} as ICrmSurveyFormActiveVm;
    const [selectedFormVm, setSelectedFormVm] = useState<ICrmSurveyFormActiveVm>(temp);
    const [answerText, setAnswerText] = useState<ICrmSurveyAnswer[]>([]);
    const [error, setError] = useState<{ question_id: number; message: string }[]>([]);
    const [dm_truong_id, setDmTruongId] = useState<number>(0);
    const [dm_khoi_id, setDmKhoiId] = useState<number>(0);
    const [dm_he_id, setDmHeId] = useState<number>(0);

    const [isRegisterSuccess, setIsRegisterSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [ticketInfo, setTicketInfo] = useState<ICrmTicketVm | null>(null);
    const [ticketError, setTicketError] = useState<string>("");
    const [isPhInfoFilled, setIsPhInfoFilled] = useState(false);
    const [disabledInputs, setDisabledInputs] = useState<Set<string>>(new Set());
    const [familyRelationChanged, setFamilyRelationChanged] = useState(false);
    const [previousFamilyRelation, setPreviousFamilyRelation] = useState<string>("");
    const [chienDichInfo, setChienDichInfo] = useState<IDmChienDich | null>(null);
    const [showNeedLogin, setShowNeedLogin] = useState(false);
    const [activeMobileCampaigns, setActiveMobileCampaigns] = useState<IDmChienDich[]>([]);
    const [availableCoSos, setAvailableCoSos] = useState<dm_coso[]>([]);
    const [showCoSoSelector, setShowCoSoSelector] = useState(false);
    const { translate } = useCommonContext();
    const location = useLocation();
    const params = location.pathname.replace('/crm_survey_register/', '').split('/').filter(p => p.length > 0);
    console.log({
        pathname: location.pathname,
        params
    });

    const dm_nguonbiettoi_id = (() => {
        if (params.length > 0) {
            const parts = params[0].split('_');
            if (parts.length > 1) {
                const parsed = parseInt(parts[1]);
                return isNaN(parsed) ? 0 : parsed;
            }
        }
        return 0;
    })();
    const dm_chiendich_id = props.dm_chiendich_id || (() => {
        if (params.length > 1) {
            const parsed = parseInt(params[1]);
            return isNaN(parsed) ? 0 : parsed;
        }
        return 0;
    })();
    const crm_survey_form_id = props.crm_survey_form_id || (() => {
        if (params.length > 2) {
            const parsed = parseInt(params[2]);
            return isNaN(parsed) ? 0 : parsed;
        }
        return 0;
    })();
    useEffect(() => {
        if (crm_survey_form_id > 0)
            handleGetDetailAsync();
    }, [crm_survey_form_id])

    // Kiểm tra có nhiều chiến dịch active mobile không
    useEffect(() => {
        const checkActiveMobileCampaigns = async () => {
            try {
                // Lấy tất cả chiến dịch
                const allCampaignsResponse = await apiGuestClient.get('chien-dich');
                if (allCampaignsResponse.is_success) {
                    // Lọc các chiến dịch đang active mobile
                    const activeCampaigns = allCampaignsResponse.data.filter((campaign: any) => 
                        campaign.is_active_mobile && 
                        campaign.crm_survey_form_id > 0 &&
                        !campaign.is_locked
                    );
                    
                    setActiveMobileCampaigns(activeCampaigns);
                    
                    // Nếu có nhiều hơn 1 chiến dịch active mobile
                    if (activeCampaigns.length > 1) {
                        // Lấy danh sách cơ sở có chiến dịch active
                        const coSoIds = activeCampaigns.map((c: any) => c.dm_coso_id);
                        const uniqueCoSoIds = coSoIds.filter((id: number, index: number) => coSoIds.indexOf(id) === index);
                        
                        if (uniqueCoSoIds.length > 1) {
                            // Lấy thông tin chi tiết các cơ sở
                            const coSosResponse = await apiGuestClient.get('co-so');
                            if (coSosResponse.is_success) {
                                const availableCoSos = coSosResponse.data.filter((coso: dm_coso) => 
                                    uniqueCoSoIds.includes(coso.id)
                                );
                                setAvailableCoSos(availableCoSos);
                                setShowCoSoSelector(true);
                            }
                        }
                    }
                }
            } catch (error) {
                console.error("Error checking active mobile campaigns:", error);
            }
        };

        checkActiveMobileCampaigns();
    }, [])

    // Lấy thông tin chiến dịch để kiểm tra is_need_login
    useEffect(() => {
        const getChienDichInfo = async () => {
            if (props.dm_chiendich_id > 0) {
                try {
                    const response = await apiGuestClient.get(`chien-dich/${props.dm_chiendich_id}`);
                    if (response.is_success) {
                        setChienDichInfo(response.data);

                        // Kiểm tra xem có cần đăng nhập không
                        if (response.data.is_need_login) {
                            // Nếu cần đăng nhập và không có UUID thì hiển thị thông báo
                            if (!props.uuid) {
                                setShowNeedLogin(true);
                            }
                        }
                    }
                } catch (error) {
                    console.error("Error getting chien dich info:", error);
                }
            }
        };

        getChienDichInfo();
    }, [props.dm_chiendich_id, props.uuid])

    // Lấy thông tin ticket khi có UUID
    useEffect(() => {
        const getTicketInfo = async () => {
            if (props.uuid) {
                try {
                    setIsLoading(true);
                    const response = await apiGuestClient.get(`crm-ticket/uuid/${props.uuid}`);
                    if (response.is_success) {
                        setTicketInfo(response.data);
                        setTicketError("");
                        // Nếu có UUID hợp lệ thì ẩn thông báo cần đăng nhập
                        setShowNeedLogin(false);
                    } else {
                        setTicketError(response.message || "Không thể lấy thông tin ticket hoặc ticket đã hết hạn");
                        setTicketInfo(null);
                    }
                } catch (error: any) {
                    console.error("Error getting ticket info:", error);
                    setTicketError("Không thể lấy thông tin ticket hoặc ticket đã hết hạn");
                    setTicketInfo(null);
                } finally {
                    setIsLoading(false);
                }
            }
        };

        getTicketInfo();
    }, [props.uuid])

    // Logic fill dữ liệu từ UUID đã được bỏ theo yêu cầu

    // Xử lý auto-fill thông tin phụ huynh khi người dùng chọn quan hệ gia đình
    useEffect(() => {
        if (familyRelationChanged && selectedFormVm.questions && ticketInfo) {
            // Tìm câu trả lời có quan hệ gia đình (bất kỳ đáp án nào)
            const familyRelationAnswer = answerText.find(answer => {
                const question = selectedFormVm.questions?.find(q => q.id === answer.crm_survey_form_question_id);
                return question && question.datasource_querry &&
                       question.datasource_querry.includes("dm_quanhe");
            });

            if (familyRelationAnswer) {
                // Chỉ fill dữ liệu phụ huynh khi chọn "Bố" hoặc "Mẹ"
                const isBoOrMe = familyRelationAnswer.answer_text === "Bố" || familyRelationAnswer.answer_text === "Mẹ";

                if (isBoOrMe && !isPhInfoFilled) {
                    // Tìm các câu hỏi cần fill thông tin phụ huynh
                    const phInfoPhoneQuestions = selectedFormVm.questions?.filter(q =>
                        q.datasource_querry === "ph_info_phone" &&
                        q.crm_survey_form_question_type_id === eSurveyFormQuestionTypeId.TEXT_INPUT
                    ) || [];

                    const phInfoNameQuestions = selectedFormVm.questions?.filter(q =>
                        q.datasource_querry === "ph_info_name" &&
                        q.crm_survey_form_question_type_id === eSurveyFormQuestionTypeId.TEXT_INPUT
                    ) || [];

                    setAnswerText((prevAnswers: any) => {
                        let updatedAnswers = [...prevAnswers];

                        // Fill số điện thoại phụ huynh
                        phInfoPhoneQuestions.forEach(question => {
                            const existingAnswerIndex = updatedAnswers.findIndex(
                                (answer: any) => answer.crm_survey_form_question_id === question.id
                            );

                            if (existingAnswerIndex >= 0) {
                                updatedAnswers[existingAnswerIndex] = {
                                    ...updatedAnswers[existingAnswerIndex],
                                    answer_text: ticketInfo.phuhuynh_sodienthoai,
                                };
                            } else {
                                updatedAnswers.push({
                                    crm_survey_form_question_id: question.id,
                                    crm_survey_form_question_option_id: 0,
                                    answer_text: ticketInfo.phuhuynh_sodienthoai,
                                });
                            }
                        });

                        // Fill họ tên phụ huynh
                        phInfoNameQuestions.forEach(question => {
                            const existingAnswerIndex = updatedAnswers.findIndex(
                                (answer: any) => answer.crm_survey_form_question_id === question.id
                            );

                            if (existingAnswerIndex >= 0) {
                                updatedAnswers[existingAnswerIndex] = {
                                    ...updatedAnswers[existingAnswerIndex],
                                    answer_text: ticketInfo.phuhuynh_hoten,
                                };
                            } else {
                                updatedAnswers.push({
                                    crm_survey_form_question_id: question.id,
                                    crm_survey_form_question_option_id: 0,
                                    answer_text: ticketInfo.phuhuynh_hoten,
                                });
                            }
                        });

                        return updatedAnswers;
                    });

                    // Disable các input đã được fill
                    setDisabledInputs(prev => {
                        const newSet = new Set(prev);
                        phInfoPhoneQuestions.forEach(q => newSet.add(`phone_${q.id}`));
                        phInfoNameQuestions.forEach(q => newSet.add(`name_${q.id}`));
                        return newSet;
                    });

                    setIsPhInfoFilled(true);
                } else if (!isBoOrMe) {
                    // Nếu không chọn "Bố" hoặc "Mẹ" thì clear dữ liệu và enable input
                    // Tìm các câu hỏi cần clear thông tin phụ huynh
                    const phInfoPhoneQuestions = selectedFormVm.questions?.filter(q =>
                        q.datasource_querry === "ph_info_phone" &&
                        q.crm_survey_form_question_type_id === eSurveyFormQuestionTypeId.TEXT_INPUT
                    ) || [];

                    const phInfoNameQuestions = selectedFormVm.questions?.filter(q =>
                        q.datasource_querry === "ph_info_name" &&
                        q.crm_survey_form_question_type_id === eSurveyFormQuestionTypeId.TEXT_INPUT
                    ) || [];

                    // Kiểm tra xem có dữ liệu phụ huynh nào đã được fill không
                    const hasPhInfoData = answerText.some(answer => {
                        const question = selectedFormVm.questions?.find(q => q.id === answer.crm_survey_form_question_id);
                        return question && 
                               (question.datasource_querry === "ph_info_phone" || question.datasource_querry === "ph_info_name") &&
                               answer.answer_text && answer.answer_text.trim() !== '';
                    });

                    // Chỉ clear nếu có dữ liệu phụ huynh hoặc có input bị disabled
                    if (hasPhInfoData || disabledInputs.size > 0) {
                        setAnswerText((prevAnswers: any) => {
                            let updatedAnswers = [...prevAnswers];

                            // Clear số điện thoại phụ huynh
                            phInfoPhoneQuestions.forEach(question => {
                                const existingAnswerIndex = updatedAnswers.findIndex(
                                    (answer: any) => answer.crm_survey_form_question_id === question.id
                                );

                                if (existingAnswerIndex >= 0) {
                                    updatedAnswers[existingAnswerIndex] = {
                                        ...updatedAnswers[existingAnswerIndex],
                                        answer_text: '',
                                    };
                                }
                            });

                            // Clear họ tên phụ huynh
                            phInfoNameQuestions.forEach(question => {
                                const existingAnswerIndex = updatedAnswers.findIndex(
                                    (answer: any) => answer.crm_survey_form_question_id === question.id
                                );

                                if (existingAnswerIndex >= 0) {
                                    updatedAnswers[existingAnswerIndex] = {
                                        ...updatedAnswers[existingAnswerIndex],
                                        answer_text: '',
                                    };
                                }
                            });

                            return updatedAnswers;
                        });

                        // Enable lại các input
                        setDisabledInputs(prev => {
                            const newSet = new Set(prev);
                            phInfoPhoneQuestions.forEach(q => newSet.delete(`phone_${q.id}`));
                            phInfoNameQuestions.forEach(q => newSet.delete(`name_${q.id}`));
                            return newSet;
                        });
                    }

                    setIsPhInfoFilled(false);
                }
            } else {
                // Nếu không có quan hệ gia đình được chọn thì clear dữ liệu và enable input
                setIsPhInfoFilled(false);

                // Tìm các câu hỏi cần clear thông tin phụ huynh
                const phInfoPhoneQuestions = selectedFormVm.questions?.filter(q =>
                    q.datasource_querry === "ph_info_phone" &&
                    q.crm_survey_form_question_type_id === eSurveyFormQuestionTypeId.TEXT_INPUT
                ) || [];

                const phInfoNameQuestions = selectedFormVm.questions?.filter(q =>
                    q.datasource_querry === "ph_info_name" &&
                    q.crm_survey_form_question_type_id === eSurveyFormQuestionTypeId.TEXT_INPUT
                ) || [];

                if (phInfoPhoneQuestions.length > 0 || phInfoNameQuestions.length > 0) {
                    setAnswerText((prevAnswers: any) => {
                        let updatedAnswers = [...prevAnswers];

                        // Clear số điện thoại phụ huynh
                        phInfoPhoneQuestions.forEach(question => {
                            const existingAnswerIndex = updatedAnswers.findIndex(
                                (answer: any) => answer.crm_survey_form_question_id === question.id
                            );

                            if (existingAnswerIndex >= 0) {
                                updatedAnswers[existingAnswerIndex] = {
                                    ...updatedAnswers[existingAnswerIndex],
                                    answer_text: '',
                                };
                            }
                        });

                        // Clear họ tên phụ huynh
                        phInfoNameQuestions.forEach(question => {
                            const existingAnswerIndex = updatedAnswers.findIndex(
                                (answer: any) => answer.crm_survey_form_question_id === question.id
                            );

                            if (existingAnswerIndex >= 0) {
                                updatedAnswers[existingAnswerIndex] = {
                                    ...updatedAnswers[existingAnswerIndex],
                                    answer_text: '',
                                };
                            }
                        });

                        return updatedAnswers;
                    });

                    // Enable lại các input
                    setDisabledInputs(new Set());
                }
            }

            setFamilyRelationChanged(false); // Reset flag
        }
    }, [familyRelationChanged, selectedFormVm.questions, ticketInfo, isPhInfoFilled, previousFamilyRelation])

    // Theo dõi sự thay đổi từ dropdown quan hệ gia đình
    useEffect(() => {
        if (answerText.length > 0 && selectedFormVm.questions) {
            const familyRelationQuestion = selectedFormVm.questions.find(q =>
                q.datasource_querry && q.datasource_querry.includes("dm_quanhe")
            );

            if (familyRelationQuestion) {
                const familyRelationAnswer = answerText.find(answer =>
                    answer.crm_survey_form_question_id === familyRelationQuestion.id
                );

                if (familyRelationAnswer && familyRelationAnswer.answer_text) {
                    const currentRelation = familyRelationAnswer.answer_text;

                    // Nếu quan hệ gia đình thay đổi, chỉ cập nhật previousFamilyRelation
                    // Để logic clear dữ liệu có thể chạy dựa trên isPhInfoFilled hiện tại
                    if (previousFamilyRelation && previousFamilyRelation !== currentRelation) {
                        setPreviousFamilyRelation(currentRelation);
                    } else if (!previousFamilyRelation) {
                        setPreviousFamilyRelation(currentRelation);
                    }

                    setFamilyRelationChanged(true);
                } else if (previousFamilyRelation) {
                    // Nếu không có quan hệ gia đình được chọn (dropdown bị clear), reset trạng thái
                    setIsPhInfoFilled(false);
                    setDisabledInputs(new Set());
                    setPreviousFamilyRelation("");
                    setFamilyRelationChanged(true);
                }
            }
        }
    }, [answerText, selectedFormVm.questions, previousFamilyRelation])

    const handleGetDetailAsync = async () => {
        setIsLoading(true)
        const res = await crmSurveyFormApi.selectDetail(crm_survey_form_id);
        if (res.is_success) {
            setSelectedFormVm(res.data)
        }
        setIsLoading(false)
    }

    // Đảm bảo tất cả câu hỏi đều có entry trong answerText mà không làm mất dữ liệu hiện có
    useEffect(() => {
        if (selectedFormVm.questions && selectedFormVm.questions.length > 0) {
            setAnswerText((prevAnswers: any) => {
                const existingQuestionIds = prevAnswers.map((answer: any) => answer.crm_survey_form_question_id);
                const missingQuestions = selectedFormVm.questions.filter(
                    (question: any) => !existingQuestionIds.includes(question.id)
                );

                if (missingQuestions.length > 0) {
                    const newAnswers = missingQuestions.map((question: any) => ({
                        crm_survey_form_question_id: question.id,
                        crm_survey_form_question_option_id: 0,
                        answer_text: ''
                    }));

                    return [...prevAnswers, ...newAnswers];
                }

                return prevAnswers;
            });
        }
    }, [selectedFormVm.questions])
    useEffect(() => {
        const loadDataForQuestions = async () => {
            if (!selectedFormVm.questions || selectedFormVm.questions.length === 0) {
                return;
            }
            const updatedQuestions = await Promise.all(
                selectedFormVm.questions.map(async (question) => {
                    if (question.datasource_querry) {
                        try {
                            const res = await crmSurveyFormQuestionApi.select_datasource(question.id, dm_coso_id, 0);
                            // Chuyển đổi id từ string sang number để phù hợp với interface
                            const convertedOptions = res.data.map((option: any) => ({
                                ...option,
                                id: parseInt(option.id, 10)
                            }));
                            return {
                                ...question,
                                options: convertedOptions,
                            };
                        } catch (error) {
                            console.error(`Error loading options for question ${question.id}:`, error);
                            return question;
                        }
                    }
                    return question;
                })
            );

            setSelectedFormVm((prev) => ({
                ...prev,
                questions: updatedQuestions,
            }));
        };

        loadDataForQuestions();
    }, [selectedFormVm.form]);

    const handleValueChanged = async (crm_survey_form_id: number, crm_survey_form_question_id: number, id: number, text: string) => {
        setAnswerText((prev: any) => {
            const updatedAnswers = prev.map((answer: any) => {
                if (answer.crm_survey_form_question_id === crm_survey_form_question_id) {
                    return {
                        ...answer,
                        crm_survey_form_question_id: crm_survey_form_question_id,
                        crm_survey_form_question_option_id: id,
                        answer_text: text,
                    };
                }
                return answer;
            });
            if (!updatedAnswers.find((answer: any) => answer.crm_survey_form_question_id === crm_survey_form_question_id)) {
                return [
                    ...updatedAnswers,
                    {
                        crm_survey_form_question_id: crm_survey_form_question_id,
                        crm_survey_form_question_option_id: id,
                        answer_text: text,
                    },
                ];
            }

            return updatedAnswers;
        });

    };
    const handleRadioChange = (questionId: number, answerTextValue: string) => {
        setAnswerText((prevAnswers: any) => {
            const existingAnswerIndex = prevAnswers.findIndex((answer: any) => answer.crm_survey_form_question_id === questionId);

            if (existingAnswerIndex > -1) {
                const updatedAnswers = [...prevAnswers];
                updatedAnswers[existingAnswerIndex] = {
                    ...updatedAnswers[existingAnswerIndex],
                    answer_text: answerTextValue,
                    crm_survey_form_question_option_id: 0
                };
                return updatedAnswers;
            } else {
                return [
                    ...prevAnswers,
                    {
                        crm_survey_form_question_id: questionId, crm_survey_form_question_option_id: 0,
                        answer_text: answerTextValue
                    }
                ];
            }
        });
    };
    const handleCheckboxChange = (questionId: number, answerTextValue: string, isChecked: boolean) => {
        setAnswerText((prevAnswers: any) => {
            if (isChecked) {
                return [
                    ...prevAnswers,
                    { crm_survey_form_question_id: questionId, answer_text: answerTextValue, crm_survey_form_question_option_id: 0 }
                ];
            } else {
                return prevAnswers.filter(
                    (answer: any) => !(answer.crm_survey_form_question_id === questionId && answer.answer_text === answerTextValue)
                );
            }
        });
    };
    const handleTextInputChange = (questionId: number, newText: string) => {
        setAnswerText((prevAnswers: any) => {
            const existingAnswer = prevAnswers.find(
                (answer: any) => answer.crm_survey_form_question_id === questionId
            );
            if (existingAnswer) {
                return prevAnswers.map((answer: any) =>
                    answer.crm_survey_form_question_id === questionId
                        ? { ...answer, answer_text: newText }
                        : answer
                );
            } else {
                return [
                    ...prevAnswers,
                    { crm_survey_form_question_id: questionId, answer_text: newText, crm_survey_form_question_option_id: 0 }
                ];
            }
        });
    };
    const validateForm = () => {
        const newErrors: { question_id: number; message: string }[] = [];
        selectedFormVm.questions?.forEach(question => {
            if (question.is_required) {
                const answer = answerText.find(a => a.crm_survey_form_question_id === question.id);

                // Nếu không có answer nào cho câu hỏi bắt buộc
                if (!answer) {
                    newErrors.push({ question_id: question.id, message: `Vui lòng chọn câu trả lời cho câu hỏi "${question.title}"` });
                    return;
                }

                // Kiểm tra giá trị thực tế của answer dựa trên loại câu hỏi
                switch (question.crm_survey_form_question_type_id) {
                    case eSurveyFormQuestionTypeId.TEXT_INPUT:
                        if (!answer.answer_text || answer.answer_text.trim() === '') {
                            newErrors.push({ question_id: question.id, message: `Vui lòng nhập câu trả lời cho câu hỏi "${question.title}"` });
                        }
                        break;

                    case eSurveyFormQuestionTypeId.SELECT_SINGLE_RADIO:
                    case eSurveyFormQuestionTypeId.SELECT_MULTIPLE_CHECKLIST:
                        if (!answer.answer_text || answer.answer_text.trim() === '') {
                            newErrors.push({ question_id: question.id, message: `Vui lòng chọn câu trả lời cho câu hỏi "${question.title}"` });
                        }
                        break;

                    case eSurveyFormQuestionTypeId.SELECT_SINGLE_COMBOBOX:
                        if (answer.crm_survey_form_question_option_id === 0 || !answer.answer_text || answer.answer_text.trim() === '') {
                            newErrors.push({ question_id: question.id, message: `Vui lòng chọn câu trả lời cho câu hỏi "${question.title}"` });
                        }
                        break;

                    case eSurveyFormQuestionTypeId.DATE_BOX:
                        if (!answer.answer_text || answer.answer_text.trim() === '') {
                            newErrors.push({ question_id: question.id, message: `Vui lòng chọn ngày cho câu hỏi "${question.title}"` });
                        }
                        break;
                }
            }
        });

        return newErrors;
    };

    const handleSubmitForm = async () => {
        const validationErrors = validateForm();

        if (validationErrors.length > 0) {
            setError(validationErrors);
            return;
        }

        if (validationErrors.length === 0) {
            console.log('URL params:', params);
            console.log('Parsed values:', { dm_nguonbiettoi_id, dm_chiendich_id, crm_survey_form_id });

            const crmSurveyResponse: ICrmSurveyResponse = {
                id: 0,
                dm_chiendich_id: dm_chiendich_id || 0,
                dm_nguonbiettoi_id: dm_nguonbiettoi_id || 0,
                crm_survey_form_id: crm_survey_form_id || 0,
                register_date: new Date(),
                phone_number: '',
                ho_ten: '',
                email: '',
                is_open_email_result: false,
                is_send_email_result: false,
                total_open_email_result: 0,
                crm_survey_respone_status_id: 0,
                ts_phuhuynh_id: 0
            };
            const submitQuestions: ICrmSurveyResponseVm = {
                crmSurveyResponse: crmSurveyResponse,
                questions: selectedFormVm.questions,
                answers: answerText,
                uuid: props.uuid || null,
            };
            console.log('Submitting data:', JSON.stringify(submitQuestions, null, 2));
            setIsSaving(true);
            const res = await crmSurveyResponseApi.saveChanges(submitQuestions)
            if (res.is_success) {
                setIsRegisterSuccess(true);
                setAnswerText([]);
                setError([]);
            } else {
                console.error('API Error:', res);
                alert(`Lỗi: ${res.message || 'Không thể lưu dữ liệu'}`);
            }
            setIsSaving(false);
        }
    };
    useEffect(() => {
        let newErrors = [...error];
        selectedFormVm.questions?.forEach(question => {
            if (question.is_required) {
                const answer = answerText.find(a => a.crm_survey_form_question_id === question.id);
                const errorIndex = newErrors.findIndex(err => err.question_id === question.id);

                // Kiểm tra xem answer có giá trị hợp lệ không
                let isValidAnswer = false;
                if (answer) {
                    switch (question.crm_survey_form_question_type_id) {
                        case eSurveyFormQuestionTypeId.TEXT_INPUT:
                            isValidAnswer = Boolean(answer.answer_text && answer.answer_text.trim() !== '');
                            break;
                        case eSurveyFormQuestionTypeId.SELECT_SINGLE_RADIO:
                        case eSurveyFormQuestionTypeId.SELECT_MULTIPLE_CHECKLIST:
                            isValidAnswer = Boolean(answer.answer_text && answer.answer_text.trim() !== '');
                            break;
                        case eSurveyFormQuestionTypeId.SELECT_SINGLE_COMBOBOX:
                            isValidAnswer = Boolean(answer.crm_survey_form_question_option_id > 0 && answer.answer_text && answer.answer_text.trim() !== '');
                            break;
                        case eSurveyFormQuestionTypeId.DATE_BOX:
                            isValidAnswer = Boolean(answer.answer_text && answer.answer_text.trim() !== '');
                            break;
                        default:
                            isValidAnswer = true; // Các loại khác mặc định hợp lệ nếu có answer
                    }
                }

                // Nếu có answer hợp lệ thì xóa lỗi
                if (isValidAnswer && errorIndex !== -1) {
                    newErrors.splice(errorIndex, 1);
                }
            }
        });

        setError(newErrors);
    }, [answerText, selectedFormVm.questions]);

    // Xử lý chọn cơ sở khác
    const handleCoSoChange = (selectedCoSoId: number) => {
        // Tìm chiến dịch active mobile của cơ sở được chọn
        const selectedCampaign = activeMobileCampaigns.find(campaign => 
            campaign.dm_coso_id === selectedCoSoId
        );
        
        if (selectedCampaign) {
            // Tạo URL mới theo cấu trúc /crm_survey_register/ex/{campaign_id}/{form_id}
            let newUrl = `/crm_survey_register/ex/${selectedCampaign.id}/${selectedCampaign.crm_survey_form_id}`;
            
            // Giữ nguyên phần UUID nếu có
            if (props.uuid) {
                newUrl += `/${props.uuid}`;
            }
            
            // Điều hướng đến URL mới
            window.location.href = newUrl;
        }
    };

    // Nếu cần đăng nhập và không có UUID thì hiển thị thông báo
    if (showNeedLogin) {
        return (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "100vh",
                    padding: 2,
                }}
            >
                <Box
                    sx={{
                        borderRadius: 3,
                        maxWidth: 500,
                        width: "80%",
                        display: "flex",
                        flexDirection: "column",
                        padding: 5,
                        textAlign: "center",
                        backgroundColor: "#fff",
                        boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
                        border: "1px solid #e1e5e9"
                    }}
                >
                    <Box sx={{ mb: 3, textAlign: "center" }}>
                        <Box sx={{ mb: 3 }}>
                            <LockIcon size={48} />
                        </Box>
                        <Box sx={{ mb: 3 }}>
                            <Text
                                sx={{
                                    fontSize: "28px",
                                    fontWeight: "600",
                                    color: "#0969da",
                                    mb: 1,
                                    display: "block"
                                }}
                                text="Chưa được xác thực"
                            />
                            <Text
                                sx={{
                                    fontSize: "14px",
                                    color: "#656d76",
                                    lineHeight: 1.6,
                                    maxWidth: "300px",
                                    margin: "0 auto"
                                }}
                                text="Unauthorized"
                            />
                        </Box>

                        <Box sx={{ mt: 2 }}>
                            <Text
                                sx={{
                                    fontSize: "14px",
                                    color: "#0969da",
                                    lineHeight: 1.6,
                                    maxWidth: "300px",
                                    margin: "0 auto"
                                }}
                                text="Bạn cần đăng nhập Edi-Parents để đăng ký tuyển sinh"
                            />
                        </Box>
                    </Box>                   
                </Box>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                padding: 2,
            }}
        >
            <Box
                sx={{
                    borderRadius: 2,
                    maxWidth: 850,
                    width: "80%",
                    display: "flex",
                    flexDirection: "column",
                    padding: 2,
                    margin: "0 auto",

                    "@media (max-width: 1200px)": {
                        maxWidth: 800,
                    },
                    "@media (max-width: 1024px)": {
                        maxWidth: 500,
                    },
                    "@media (max-width: 768px)": {
                        maxWidth: 450,
                    },
                    "@media (max-width: 600px)": {
                        width: "100%",
                        height: "100vh",
                    },
                }}
            >
                {!isRegisterSuccess && selectedFormVm.form?.cover_img && (
                    <img
                        src={selectedFormVm.form?.cover_img}
                        alt="cover"
                        style={{
                            width: "100%",
                            height: "auto",
                            borderRadius: "10px"
                        }}
                    />
                )}

                {isRegisterSuccess && (
                    <>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                minHeight: '30vh',
                                textAlign: 'center',
                                maxWidth: 850,
                                width: "80%",
                                padding: 2,
                                margin: "0 auto",
                                "@media (max-width: 1200px)": {
                                    maxWidth: 800,
                                },
                                "@media (max-width: 1024px)": {
                                    maxWidth: 600,
                                },
                                "@media (max-width: 768px)": {
                                    maxWidth: 500,
                                },
                                "@media (max-width: 600px)": {
                                    width: "90%",
                                    height: "100vh",
                                    padding: 1,
                                },
                            }}
                        >
                            <img
                                src={selectedFormVm.form?.cover_img}
                                alt="cover"
                                style={{
                                    maxWidth: '100%',
                                    height: 'auto',
                                    borderRadius: "10px",
                                    marginBottom: 16,
                                }}
                            />
                            <img src='https://static.vecteezy.com/system/resources/previews/006/793/534/non_2x/thank-you-speech-banner-bubble-icon-for-graphic-design-logo-website-social-media-mobile-app-sticker-banner-label-ui-free-vector.jpg'
                                style={{
                                    height: "200px"
                                }}
                                alt='tks'
                            />
                            {/* <img
                                src="../../../images/thank-you.png"
                                alt="Thank You"
                                style={{ maxWidth: '80%', height: 300, marginBottom: 16 }}
                            /> */}
                            <Text
                                sx={{
                                    fontSize: "15px",
                                    fontWeight: "650",
                                    m: 2,
                                }}
                                text="Quý Phụ huynh đã đăng ký thành công!"
                            />
                            {/* <Text text="Phòng tuyển sinh sẽ liên hệ lại với phụ huynh trong thời gian sớm nhất." /> */}
                            <Box sx={{
                                display: "flex",
                                justifyContent: "center",
                                m: 2,
                            }}>
                                <Button
                                    text="Trở lại"
                                    variant="invisible"
                                    size="medium"
                                    isLoading={isLoading}
                                    onClick={() => { setIsRegisterSuccess(false); }}
                                    icon={UndoIcon}
                                />
                            </Box>
                        </Box>


                    </>
                )}
                {!isRegisterSuccess && (
                    <>
                        {/* Hiển thị combobox chọn cơ sở nếu có nhiều cơ sở active mobile */}
                        {showCoSoSelector && availableCoSos.length > 1 && (
                            <Box sx={{
                                mt: 3,
                                mb: 0,
                                p: 0,                            
                            }}>
                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                    gap: 3
                                }}>
                                    <Text
                                        sx={{
                                            fontSize: '13px',
                                            fontWeight: 'bold',
                                            color: '#374151',
                                            whiteSpace: 'nowrap'
                                        }}
                                        text="Cơ sở:"
                                    />
                                    <Box sx={{
                                        minWidth: '200px',
                                        maxWidth: '300px'
                                    }}>
                                        <ComboboxCoSo
                                            value={(() => {
                                                const currentCampaign = activeMobileCampaigns.find(c => c.id === dm_chiendich_id);
                                                return currentCampaign?.dm_coso_id || 0;
                                            })()}
                                            onValueChanged={handleCoSoChange}
                                            coSoList={availableCoSos}
                                            width="100%"
                                        />
                                    </Box>
                                </Box>
                            </Box>
                        )}

                        {/* Hiển thị thông tin ticket nếu có */}
                        {ticketError && (
                            <Box sx={{ mb: 2, p: 2, border: '1px solid #d73a49', borderRadius: '10px', backgroundColor: '#ffeaea' }}>
                                <Text
                                    sx={{ color: '#d73a49', fontSize: '14px', fontWeight: 'bold' }}
                                    text={ticketError}
                                />
                            </Box>
                        )}
                        

                        <Box sx={{ mb: 2, border: '1px solid #d0d7de', borderRadius: '10px', marginTop: '10px' }}>
                            <Box sx={{ pt: 3, pb: 1 }} id="form-name">
                                <Text
                                    text={selectedFormVm.form?.name}
                                    sx={{
                                        fontSize: "24px",
                                        fontWeight: "600",
                                        ml: 3
                                    }}
                                />
                            </Box>
                            <Box id="form-description">
                                <div
                                    dangerouslySetInnerHTML={{ __html: selectedFormVm.form?.description }}
                                    style={{ whiteSpace: "pre-line", marginLeft: 15, marginBottom: 20 }}
                                />
                            </Box>
                        </Box>

                        <Box>
                            {selectedFormVm.questions?.map((question, idx) => (
                                <SurveyFormBlock key={idx} formQuestionSelectedIds={[]} >
                                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                                        <Box sx={{ mb: 2 }}>
                                             <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                                 <Text text={question.title} sx={{ fontWeight: 600 }} />
                                                 {question.is_required && <span style={{ color: 'red', marginLeft: '4px' }}>*</span>}
                                             </Box>
                                            <Box id="question-description">
                                                <Text
                                                    text={question.description}
                                                    sx={{
                                                        whiteSpace: "pre-line",
                                                    }}
                                                />
                                            </Box>
                                        </Box>
                                        {question.image && (
                                            <Box>
                                                <img
                                                    src={question.image}
                                                    style={{
                                                        width: "100%",
                                                        height: "auto",
                                                    }}
                                                    alt=""
                                                />
                                            </Box>
                                        )}
                                        <Box>
                                            {question.crm_survey_form_question_type_id === eSurveyFormQuestionTypeId.SELECT_SINGLE_RADIO && (
                                                <>
                                                    {question.options?.map((option, j) => (
                                                        <>
                                                            <FormControl key={j}>
                                                                <Radio
                                                                    value={option.text}
                                                                    checked={answerText.some(answer => answer.crm_survey_form_question_id === question.id && answer.answer_text === option.text)}
                                                                    onChange={() => {
                                                                        handleRadioChange(question.id, option.text);
                                                                    }}
                                                                />
                                                                <FormControl.Label>{option.text}</FormControl.Label>
                                                            </FormControl>

                                                        </>
                                                    ))}
                                                    {question.is_required && error.some(err => err.question_id === question.id) && (
                                                        <Box sx={{ mt: 2 }}>
                                                            <span style={{ marginRight: "5px", color: 'red' }}><AlertIcon size={"small"} /></span>
                                                            <span style={{ marginRight: "5px", color: 'red' }}>
                                                                <TextTranslated value={error.find(err => err.question_id === question.id)?.message ?? ''} />
                                                            </span>
                                                        </Box>
                                                    )}
                                                </>
                                            )}
                                            {question.crm_survey_form_question_type_id === eSurveyFormQuestionTypeId.SELECT_MULTIPLE_CHECKLIST && (
                                                <>
                                                    {question.options?.map((option, j) => (
                                                        <FormControl key={j}>
                                                            <Checkbox
                                                                value={option.text}
                                                                checked={answerText.some(answer => answer.crm_survey_form_question_id === question.id && answer.answer_text === option.text)}
                                                                onChange={(e) => handleCheckboxChange(question.id, option.text, e.target.checked)}
                                                            />
                                                            <FormControl.Label>{option.text}</FormControl.Label>
                                                        </FormControl>
                                                    ))}
                                                    {question.is_required && error.some(err => err.question_id === question.id) && (
                                                        <Box sx={{ mt: 2 }}>
                                                            <span style={{ marginRight: "5px", color: 'red' }}><AlertIcon size={"small"} /></span>
                                                            <span style={{ marginRight: "5px", color: 'red' }}>
                                                                <TextTranslated value={error.find(err => err.question_id === question.id)?.message ?? ''} />
                                                            </span>
                                                        </Box>
                                                    )}
                                                </>
                                            )}
                                            {question.crm_survey_form_question_type_id === eSurveyFormQuestionTypeId.TEXT_INPUT && (
                                                <>
                                                    <TextInput
                                                        block
                                                        placeholder="Nhập câu trả lời của bạn"
                                                        value={answerText.find(answer => answer.crm_survey_form_question_id === question.id)?.answer_text || ''}
                                                        onChange={(e) => handleTextInputChange(question.id, e.target.value)}
                                                        disabled={disabledInputs.has(`phone_${question.id}`) || disabledInputs.has(`name_${question.id}`)}
                                                    />
                                                    {question.is_required && error.some(err => err.question_id === question.id) && (
                                                        <Box sx={{ mt: 2 }}>
                                                            <span style={{ marginRight: "5px", color: 'red' }}><AlertIcon size={"small"} /></span>
                                                            <span style={{ marginRight: "5px", color: 'red' }}>
                                                                <TextTranslated value={error.find(err => err.question_id === question.id)?.message ?? ''} />
                                                            </span>
                                                        </Box>
                                                    )}
                                                </>
                                            )}
                                            {(question.crm_survey_form_question_type_id === eSurveyFormQuestionTypeId.SELECT_SINGLE_COMBOBOX && !question.datasource_querry) && (
                                                <>
                                                    <CrmSurveyComboBoxStatic
                                                        options={question.options?.map((o: any) => ({ id: o.id, text: o.text })) || []}
                                                        value={
                                                            Array.isArray(answerText)
                                                                ? answerText.find(answer => answer.crm_survey_form_question_id === question.id)?.crm_survey_form_question_option_id || 0
                                                                : 0
                                                        }
                                                        onValueChanged={(id: number, data?: { id: number; text: string }) => {
                                                            if (data) {
                                                                handleValueChanged(question.crm_survey_form_id, question.id, id, data.text);
                                                            } else {
                                                                handleValueChanged(question.crm_survey_form_id, question.id, id, '');
                                                            }
                                                        }}
                                                        width={'100%'}
                                                        align="left"
                                                        isShowClearButton={true}
                                                        placeholder="Chọn"
                                                    />
                                                    {question.is_required && error.some(err => err.question_id === question.id) && (
                                                        <Box sx={{ mt: 2 }}>
                                                            <span style={{ marginRight: "5px", color: 'red' }}><AlertIcon size={"small"} /></span>
                                                            <span style={{ marginRight: "5px", color: 'red' }}>
                                                                <TextTranslated value={error.find(err => err.question_id === question.id)?.message ?? ''} />
                                                            </span>
                                                        </Box>
                                                    )}
                                                </>
                                            )}
                                            {(question.crm_survey_form_question_type_id === eSurveyFormQuestionTypeId.SELECT_SINGLE_COMBOBOX && question.datasource_querry && question.crm_survey_question_type_id === 0) && (
                                                <>
                                                    <CrmSurveyComboBox
                                                        crm_survey_form_question_id={question.id}
                                                        dm_coso_id={dm_coso_id}
                                                        fieldValue={0}
                                                        align="left"
                                                        value={
                                                            Array.isArray(answerText)
                                                                ? answerText.find(answer => answer.crm_survey_form_question_id === question.id)?.crm_survey_form_question_option_id || 0
                                                                : 0
                                                        }
                                                        onValueChanged={(id: number, data?: ICrmSurveyFormQuestionDataSource) => {
                                                            if (data) {
                                                                handleValueChanged(question.crm_survey_form_id, question.id, id, data.text);
                                                            } else {
                                                                handleValueChanged(question.crm_survey_form_id, question.id, id, '');
                                                            }
                                                        }}
                                                        width={'100%'}
                                                        isShowClearButton={true}
                                                    />
                                                    {question.is_required && error.some(err => err.question_id === question.id) && (
                                                        <Box sx={{ mt: 2 }}>
                                                            <span style={{ marginRight: "5px", color: 'red' }}><AlertIcon size={"small"} /></span>
                                                            <span style={{ marginRight: "5px", color: 'red' }}>
                                                                <TextTranslated value={error.find(err => err.question_id === question.id)?.message ?? ''} />
                                                            </span>
                                                        </Box>
                                                    )}
                                                </>
                                            )}
                                            {(question.crm_survey_form_question_type_id === eSurveyFormQuestionTypeId.SELECT_SINGLE_COMBOBOX && question.crm_survey_question_type_id === eSurveyQuestionTypeId.dm_truong_id) && (
                                                <>
                                                    <CrmSurveyComboBox
                                                        crm_survey_form_question_id={question.id}
                                                        dm_coso_id={dm_coso_id}
                                                        fieldValue={dm_truong_id}
                                                        align="left"
                                                        value={
                                                            Array.isArray(answerText)
                                                                ? answerText.find(answer => answer.crm_survey_form_question_id === question.id)?.crm_survey_form_question_option_id || 0
                                                                : 0
                                                        }
                                                        onValueChanged={(id: number, data?: ICrmSurveyFormQuestionDataSource) => {
                                                            if (data) {
                                                                handleValueChanged(question.crm_survey_form_id, question.id, id, data.text);
                                                            } else {
                                                                handleValueChanged(question.crm_survey_form_id, question.id, id, '');
                                                            }
                                                            setDmTruongId(id)
                                                        }}
                                                        width={'100%'}
                                                        isShowClearButton={true}
                                                    />
                                                    {question.is_required && error.some(err => err.question_id === question.id) && (
                                                        <Box sx={{ mt: 2 }}>
                                                            <span style={{ marginRight: "5px", color: 'red' }}><AlertIcon size={"small"} /></span>
                                                            <span style={{ marginRight: "5px", color: 'red' }}>
                                                                <TextTranslated value={error.find(err => err.question_id === question.id)?.message ?? ''} />
                                                            </span>
                                                        </Box>
                                                    )}
                                                </>
                                            )}
                                            {(question.crm_survey_form_question_type_id === eSurveyFormQuestionTypeId.SELECT_SINGLE_COMBOBOX && question.crm_survey_question_type_id === eSurveyQuestionTypeId.dm_khoi_id) && (
                                                <>
                                                    <CrmSurveyComboBox
                                                        crm_survey_form_question_id={question.id}
                                                        dm_coso_id={dm_coso_id}
                                                        fieldValue={dm_truong_id}
                                                        align="left"
                                                        value={
                                                            Array.isArray(answerText)
                                                                ? answerText.find(answer => answer.crm_survey_form_question_id === question.id)?.crm_survey_form_question_option_id || 0
                                                                : 0
                                                        }
                                                        onValueChanged={(id: number, data?: ICrmSurveyFormQuestionDataSource) => {
                                                            if (data) {
                                                                handleValueChanged(question.crm_survey_form_id, question.id, id, data.text);
                                                            } else {
                                                                handleValueChanged(question.crm_survey_form_id, question.id, id, '');
                                                            }
                                                        }}
                                                        width={'100%'}
                                                        isShowClearButton={true}
                                                    />
                                                    {question.is_required && error.some(err => err.question_id === question.id) && (
                                                        <Box sx={{ mt: 2 }}>
                                                            <span style={{ marginRight: "5px", color: 'red' }}><AlertIcon size={"small"} /></span>
                                                            <span style={{ marginRight: "5px", color: 'red' }}>
                                                                <TextTranslated value={error.find(err => err.question_id === question.id)?.message ?? ''} />
                                                            </span>
                                                        </Box>
                                                    )}
                                                </>
                                            )}
                                            {(question.crm_survey_form_question_type_id === eSurveyFormQuestionTypeId.SELECT_SINGLE_COMBOBOX && question.crm_survey_question_type_id === eSurveyQuestionTypeId.dm_he_id) && (
                                                <>
                                                    <CrmSurveyComboBox
                                                        crm_survey_form_question_id={question.id}
                                                        dm_coso_id={dm_coso_id}
                                                        fieldValue={dm_he_id}
                                                        align="left"
                                                        value={
                                                            Array.isArray(answerText)
                                                                ? answerText.find(answer => answer.crm_survey_form_question_id === question.id)?.crm_survey_form_question_option_id || 0
                                                                : 0
                                                        }
                                                        onValueChanged={(id: number, data?: ICrmSurveyFormQuestionDataSource) => {
                                                            if (data) {
                                                                handleValueChanged(question.crm_survey_form_id, question.id, id, data.text);
                                                            } else {
                                                                handleValueChanged(question.crm_survey_form_id, question.id, id, '');
                                                            }
                                                            setDmHeId(id);
                                                        }}
                                                        width={'100%'}
                                                        isShowClearButton={true}
                                                    />
                                                    {question.is_required && error.some(err => err.question_id === question.id) && (
                                                        <Box sx={{ mt: 2 }}>
                                                            <span style={{ marginRight: "5px", color: 'red' }}><AlertIcon size={"small"} /></span>
                                                            <span style={{ marginRight: "5px", color: 'red' }}>
                                                                <TextTranslated value={error.find(err => err.question_id === question.id)?.message ?? ''} />
                                                            </span>
                                                        </Box>
                                                    )}
                                                </>
                                            )}
                                            {question.crm_survey_form_question_type_id === eSurveyFormQuestionTypeId.DATE_BOX && (
                                                <>
                                                    <FormControl>
                                                        <FormControl.Label visuallyHidden>Ngày</FormControl.Label>
                                                        <TextInput
                                                            sx={{ width: '100%' }}
                                                            type="date"
                                                            value={
                                                                Array.isArray(answerText) && answerText.length > 0
                                                                    ? answerText.find(answer => answer.crm_survey_form_question_id === question.id)?.answer_text || moment(new Date()).format("YYYY-MM-DD")
                                                                    : moment(new Date()).format("YYYY-MM-DD")
                                                            }
                                                            onChange={(e) => {
                                                                const selectedDate = e.target.value;
                                                                handleValueChanged(question.crm_survey_form_id, question.id, 0, moment(selectedDate).format("YYYY-MM-DD"));
                                                            }}
                                                        />
                                                    </FormControl>
                                                    {question.is_required && error.some(err => err.question_id === question.id) && (
                                                        <Box sx={{ mt: 2 }}>
                                                            <span style={{ marginRight: "5px", color: 'red' }}><AlertIcon size={"small"} /></span>
                                                            <span style={{ marginRight: "5px", color: 'red' }}>
                                                                <TextTranslated value={error.find(err => err.question_id === question.id)?.message ?? ''} />
                                                            </span>
                                                        </Box>
                                                    )}
                                                </>
                                            )}
                                        </Box>
                                    </Box>
                                </SurveyFormBlock>
                            ))}
                            <Box sx={{
                                display: "flex",
                                justifyContent: "center",

                            }}>
                                <Button
                                    text="Cập nhật"
                                    variant="primary"
                                    size="medium"
                                    isLoading={isSaving}
                                    onClick={handleSubmitForm}
                                    style={{ marginBottom: 10 }}
                                />
                            </Box>
                        </Box>
                    </>
                )}
            </Box>
        </Box >
    );
};

export default SurveyFormGoLivePage;
